<div
  class="wrapper"
  [fuPopover]="popover"
  [position]="position()"
  [offsetY]="8"
>
  @if (customContent()) {
    <ng-content></ng-content>
  } @else if (withoutIcon()) {
    <p class="tooltip">{{ title() }}</p>
  } @else {
    <fu-icon [iconName]="iconName()" size="20"></fu-icon>
  }
</div>

<ng-template #popover>
  @if (!tooltipContent()) {
    <p
      class="tooltip"
      [style.max-width]="maxWidth() ? maxWidth() + 'px' : null"
    >
      <span class="title">
        {{ title() | translate }}
      </span>

      @if (subtitle()) {
        <p class="subtitle">
          {{ subtitle() | translate }}
        </p>
      }
    </p>
  } @else {
    <div class="tooltip">
      <ng-container *ngTemplateOutlet="tooltipContent()" />
    </div>
  }
</ng-template>
